module.exports = __webpack_public_path__ + "static/img/08.97b8b936.png";